// Vuex module — Batas Waktu Penerimaan Inventori (P26_0035 FR-11).
//
// Halaman /offline-stores/receipt-sla. Endpointnya di routes/routes/unionweb.php grup
// `/receipt-sla`, dijaga auth:api + access (modul `receiptsla_*`). Setiap tulis mengembalikan
// daftar terbaru, jadi halaman cukup menimpa state dengan jawabannya.
import $axios from "../../api";

const PREFIX = "unionweb/receipt-sla";

const state = () => ({
  isLoading: false,
  stores: [],
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  SET_STORES(s, v) {
    s.stores = v?.stores || [];
  },
};

const actions = {
  async getList({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      const res = await $axios.get(`${PREFIX}/list`);
      commit("SET_STORES", res.data?.data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Penolakan 422 (urutan tidak naik, alasan kosong) dilempar ke halaman supaya kalimatnya
  // tampil di modal, bukan ditelan.
  async save({ commit }, rows) {
    const res = await $axios.post(`${PREFIX}/save`, { rows });
    commit("SET_STORES", res.data?.data);
  },

  async toggle({ commit }, { storeCode, isEnabled, reason = null }) {
    const res = await $axios.post(`${PREFIX}/toggle`, { store_code: storeCode, is_enabled: isEnabled, reason });
    commit("SET_STORES", res.data?.data);
  },
};

export default { namespaced: true, state, mutations, actions };
